import classcat from "classcat";
import React, { ChangeEvent, useCallback } from "react";

import css from "./Radio.module.css";

type Props = {
  checked: boolean;
  title: string | React.ReactNode;
  name?: string;
  disabled?: boolean;
  onChange: (name: string) => void;
  isRequired?: boolean;
  hasError?: boolean;
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "checked" | "name" | "disabled" | "onChange" | "type" | "title"
>;

const Radio = ({
  checked,
  name,
  title,
  disabled,
  onChange,
  isRequired,
  hasError,
  ...props
}: Props) => {
  const handleChange = useCallback(
    (e: ChangeEvent) => {
      onChange(e.currentTarget.getAttribute("name"));
    },
    [onChange]
  );

  return (
    <label>
      <div className={css.radio}>
        <div
          className={classcat([
            css.radioCircle,
            {
              [css.checked]: checked,
            },
          ])}
        />
        <input
          className={css.radioInput}
          type="radio"
          checked={checked}
          onChange={handleChange}
          name={name}
          disabled={disabled}
          {...props}
        />
        <span
          className={classcat([
            "text-label-xs",
            { [css.required]: isRequired },
            { [css.error]: hasError },
          ])}
        >
          {title}
        </span>
      </div>
    </label>
  );
};
export default Radio;
